import { AppState } from './reducer';

export const selectAppState = (state: any): AppState => state.app;

export const selectInitializing = (state: any) =>
  selectAppState(state).initializing;

export const selectInit = (state: any) => selectAppState(state).init;
